import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";
import { toastError, toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import CommonDatePicker from "../DatePicker/CommonDatePicker";
import moment from "moment";

const Reports = (props) => {
  const [visibleDisableModules, setVisibleDisableModules] = useState(false);
  const [formValues, setFormValues] = useState({
    ReportView: false,
    ReportDate: "",
  });
  const [comingDisableModules, setcomingDisableModules] = useState(
    props.visibleDisableModulesChange
  );

  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");

  const handleSubmit = (values) => {
    const formArray = [
      {
        AppConfigkey: "ReportView",
        AppConfigvalue: values.ReportView,
      },
      {
        AppConfigkey: "ReportDate",
        AppConfigvalue: values.ReportDate,
      },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "Reports",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=Reports`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "ReportView") {
            formValues.ReportView =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ReportDate") {
            formValues.ReportDate = data.AppConfigvalue;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   const fieldValue = type === "checkbox" ? checked : value;

  //   setFormValues((prevValues) => ({
  //     ...prevValues,
  //     [name]: fieldValue,
  //   }));
  // };

  const handleChange = (e) => {
    const { name, checked, type, value } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  const handleduedatechange = (settime) => {
    setFormValues((prev) => ({
      ...prev,
      ReportDate: settime,
    }));
  };

  const data = [
    {
      name: "Report View Permission:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="ReportView"
                name="ReportView"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Report Date:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <CommonDatePicker
                FinalDate={
                  formValues?.ReportDate == ""
                    ? moment().format("MM-DD-YYYY")
                    : formValues?.ReportDate
                }
                handleDateChange={handleduedatechange}
              />
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="card">
        <div
          style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
          className="card-header"
        >
          <h5 className="card-title">
            <CLink
              style={{ color: "var(--primary-main-color)" }}
              onClick={() => {
                setVisibleDisableModules(!visibleDisableModules);
                setcomingDisableModules(!!comingDisableModules);
              }}
            >
              Reports
            </CLink>
          </h5>
        </div>
        <CCollapse
          visible={visibleDisableModules || props.visibleDisableModulesChange}
        >
          <div className="card-body">
            <Formik
              {...props}
              initialValues={formValues}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ handleChange }) => (
                <Form>
                  {/* <button
                    type="submit"
                    className="btn btn-primary pull-right mb-3"
                  >
                    Save
                  </button> */}
                  <div
                    style={{
                      display: "flex",
                      width: "50%",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    {data &&
                      data?.map((el) => (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "10px",
                          }}
                        >
                          <label
                            className="col-form-label"
                            style={{ fontSize: "15px" }}
                          >
                            {el.name}
                          </label>
                          <div style={{ width: "53%" }}>{el.input}</div>
                        </div>
                      ))}
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary pull-right mb-3"
                  >
                    Save
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </CCollapse>
      </div>
    </>
  );
};

export default Reports;
